import HistoryCompanyItem from './HistoryCompanyItem';

export default HistoryCompanyItem;